import { useEffect, useState } from "react";
import { dispatcher, DispatcherEvents } from "../../../utils/dispatcher";

/**
 * A React hook that subscribes to specific parts of the Redux store state
 * and automatically updates the component when that state changes.
 *
 * @param store - The Redux store to subscribe to
 * @param selector - A function that selects the part of state you're interested in
 * @returns The current value of the selected state
 */
export function useDispatcherEventsSelector(
    event: DispatcherEvents
): void {
    const [,setState] = useState({});

    useEffect(() => {
        // Some emitters (e.g. UserUpdateLanguage) trigger with no payload, so `newState` is
        // always `undefined` — using it directly would make React bail out via Object.is and
        // skip the re-render. Force a fresh reference on every event instead.
        const callback = () => {
            setState({});
        };

        dispatcher.on(event, callback);

        return () => {
            dispatcher.off(event, callback);
        };
    }, [event]);
}

/**
 * @deprecated This hook is obsolete and should not be used in new code.
 * Try to use the pattern (useDispatcherEventsSelector) where we change a state
 */
export function useDispatcherEvents<T>(
    event: DispatcherEvents,
    onChange: (state?: T) => void
) {

    useEffect(() => {
        const callback = (newState: T | undefined) => {
            onChange(newState);
        };

        dispatcher.on(event, callback);

        return () => {
            dispatcher.off(event, callback);
        };
    }, [event, onChange]);
}
